module.exports = __webpack_public_path__ + "assets/049b275262e58734fcd75c0ef1d6d443.png";